export enum FENCE_NAMES {
  dcf = 'dcf',
}

export const ALL_FENCE_NAMES = [FENCE_NAMES.dcf];
